import { useEffect } from 'react';

import { App as CapacitorApp } from '@capacitor/app';

import { useBackLayerStack } from '../context/BackLayerStackContext';
import { useLayout } from '../context/LayoutContext';
import { useNavigationStack } from '../context/NavigationStackContext';
import { Paths } from '../shared/paths';
import { useWindowSize } from './use-window-size';

export default function useCapacitorBackHandler() {
  const { back } = useNavigationStack();
  const { tryDismissTop } = useBackLayerStack();
  const { isMenuOpen, hideMenu } = useLayout();
  const { mobileView } = useWindowSize();

  useEffect(() => {
    const listener = CapacitorApp.addListener('backButton', () => {
      const handleDefaultBack = () => {
        if (mobileView && isMenuOpen) {
          hideMenu();
          return;
        }

        if (window.location.pathname === Paths.root) {
          CapacitorApp.minimizeApp();
          return;
        }

        back();
      };

      if (tryDismissTop(handleDefaultBack)) {
        return;
      }

      handleDefaultBack();
    });

    return () => {
      listener.then((l) => l.remove());
    };
  }, [back, tryDismissTop, mobileView, isMenuOpen, hideMenu]);
}
